import {
  getAccessTokenForWiFiConnection,
  getRegistrationToken,
  getActualOauthServerUrl,
} from 'api/oauth-api';

export type WiFiTokens = {
  webSocketServerUrl: string;
  registrationToken: string;
  newDeviceConnectionKey?: string;
  accessToken: string;
};

/**
 * Fetches/refreshes portal access token (optionally using a device_connection_key)
 * and retrieves the CC WS server URL from the registration token helper.
 */
export const getRegistrationTokenAndAccessToken = async (
  deviceConnectionKey?: string,
  forceGettingNewToken?: boolean,
): Promise<WiFiTokens> => {
  const oauthServerUrl = getActualOauthServerUrl();
  const [registrationToken, webSocketServerUrl, accessToken] = await getRegistrationToken(
    oauthServerUrl,
    deviceConnectionKey,
    forceGettingNewToken,
  );
  if (!registrationToken || !webSocketServerUrl) {
    throw new Error('Failed to get registration token/WS URL');
  }

  return {
    registrationToken,
    webSocketServerUrl,
    accessToken,
  };
};
export const getWifiAccessTokenAndRefreshToken = async (
  deviceConnectionKey?: string,
): Promise<{ accessToken: string; refreshToken: string }> => {
  const tokens = await getAccessTokenForWiFiConnection(deviceConnectionKey || '');
  if (!tokens?.access_token) {
    throw new Error('Failed to get access token');
  }
  return { accessToken: tokens.access_token, refreshToken: tokens.refresh_token };
};
